import { useCallback } from 'react';
import { useSettingsStore } from '@annunciate/core';
import { useSettingsQuery } from '@annunciate/query';
export const useReaderPreferences = () => {
    const settings = useSettingsQuery();
    return useSettingsStore(useCallback(state => {
        return state.getReaderPreferences(settings || {});
    }, [settings?.theme]));
};
//# sourceMappingURL=useReaderPreferences.js.map